import api from './api';

export const userService = {
  // Get user profile
  getProfile: async () => {
    const response = await api.get('/users/profile');
    return response.data;
  },

  // Update user profile
  updateUser: async (userId, userData) => {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  },

  // Change password
  changePassword: async (userId, passwordData) => {
    const response = await api.put(`/users/${userId}/password`, passwordData);
    return response.data;
  },

  // Login
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  // Refresh token
  refreshToken: async (refreshToken) => {
    const response = await api.post('/auth/refresh', { refreshToken });
    return response.data;
  },

  // Logout
  logout: async (refreshToken) => {
    const response = await api.post('/auth/logout', { refreshToken });
    return response.data;
  },

  // Admin functions
  getUsers: async (accountId = null) => {
    const url = accountId ? `/users/account/${accountId}` : '/users/account';
    const response = await api.get(url);
    return response.data;
  },

createUser: async (userData) => {
  const response = await api.post('/users', userData);
  return response.data;
},

  deleteUser: async (userId) => {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  },

  updateUserStatus: async (userId, statusData) => {
    const response = await api.put(`/users/${userId}/status`, statusData);
    return response.data;
  },

  // Get all accounts (for master admin)
  getAccounts: async (params = {}) => {
    const response = await api.get('/accounts', { params });
    return response.data;
  },

  getAccount: async (accountId) => {
    const response = await api.get(`/accounts/${accountId}`);
    return response.data;
  },

  createAccount: async (accountData) => {
    const response = await api.post('/accounts', accountData);
    return response.data;
  },

  updateAccount: async (accountId, accountData) => {
    const response = await api.put(`/accounts/${accountId}`, accountData);
    return response.data;
  },

  deleteAccount: async (accountId) => {
    const response = await api.delete(`/accounts/${accountId}`);
    return response.data;
  },

  getAccountStats: async () => {
    const response = await api.get('/accounts/stats');
    return response.data; // This is correct for stats
  },

  renewSubscription: async (accountId, renewalData) => {
    const response = await api.put(`/accounts/${accountId}/renew`, renewalData);
    return response.data;
  },

  extendSubscription: async (accountId, extensionData) => {
    const response = await api.put(`/accounts/${accountId}/extend`, extensionData);
    return response.data;
  },

  cancelSubscription: async (accountId) => {
    const response = await api.put(`/accounts/${accountId}/cancel`);
    return response.data;
  },

  getPreferences: async () => {
    const response = await api.get('/users/preferences');
    return response.data;
  },

  updatePreferences: async (preferences) => {
    const response = await api.put('/users/preferences', preferences);
    return response.data;
  }

};




export default userService;